<template>
  <ResponsiveImage
    v-if="url"
    :url="url"
    :alt="alt"
    :title="title"
    :hash="hash"
    :responsive-style="responsiveStyle"
    :no-lazy-loading="noLazyLoading"
    :image-class="imageClass"
    :no-draggable="noDraggable"
  />
</template>

<script lang="ts" setup>
/* Old code:
export default Vue.extend({
 name: 'MediaImage',
 components: {
   ResponsiveImage,
 },
 props: {
   media: {
     type: Object,
     default: undefined,
   } as PropOptions<MediaImageFragment>,
   responsiveStyle: {
     type: String,
     default: DEFAULT_STYLE,
   } as PropOptions<string>,
   noLazyLoading: {
     type: Boolean,
     default: false,
   } as PropOptions<boolean>,
 },
*/

import type { MediaImageFragment } from '#graphql-operations'
import type { ResponsiveStyleName } from '~/helpers/responsiveStyles'
import type { ClassProp } from '~/types/vue'

const props = withDefaults(
  defineProps<{
    mid?: string
    fileUrl?: MediaImageFragment['fileUrl']
    image?: MediaImageFragment['image']
    changed?: string
    responsiveStyle?: ResponsiveStyleName
    noLazyLoading?: boolean
    imageClass?: ClassProp
    noDraggable?: boolean
  }>(),
  {
    media: undefined,
    mid: '',
    fileUrl: undefined,
    image: undefined,
    changed: '',
    responsiveStyle: 'column_full',
    noLazyLoading: false,
    imageClass: undefined,
    noDraggable: false,
  },
)

/* Old code:
computed: {
 url(): string {
   return this.image?.url as string
 },
 image(): MediaImageImageFragment | null {
   return this.media?.image || null
 },
 alt(): string {
   return this.image?.alt || (this as any).altFallback || ''
 },
 title(): string {
   return this.image?.title || ''
 },
 mid(): number | null {
   return this.media?.mid || null
 },
 hash(): string {
   return this.media?.changed || ''
 },
*/

const url = computed(() => props.fileUrl?.path)

// @TODO: Need to check where altFallback comes from in original code
const alt = computed(() => props.image?.alt)

const title = computed(() => props.image?.title)

const hash = computed(() => props.changed || '')
</script>
